import DOMPurify from 'dompurify';

// Sanitize rich-text / HTML strings before rendering with dangerouslySetInnerHTML.
export const sanitizeHtml = (html) => DOMPurify.sanitize(html || '');

export default sanitizeHtml;
